import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './UserMenuCollagesSection.css';

/**
 * Coupon code entry dialog (opened from navbar user menu).
 */
export default function CouponRedeemModal({ open, onClose, onRedeemCoupon }) {
  const [couponInput, setCouponInput] = useState('');
  const [couponError, setCouponError] = useState('');
  const [couponSubmitting, setCouponSubmitting] = useState(false);

  useEffect(() => {
    if (!open) return;
    setCouponInput('');
    setCouponError('');
    setCouponSubmitting(false);
  }, [open]);

  const closeModal = () => {
    if (couponSubmitting) return;
    onClose?.();
  };

  if (!open || typeof onRedeemCoupon !== 'function') return null;

  return createPortal(
    <div
      className="user-menu-match-removal-confirm-overlay"
      role="presentation"
      onClick={closeModal}
    >
      <div
        className="user-menu-match-removal-confirm cart-popup vibe-popup user-menu-coupon-redeem-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="user-menu-coupon-redeem-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="cart-popup-close"
          aria-label="Close"
          disabled={couponSubmitting}
          onClick={closeModal}
        >
          ×
        </button>
        <h3 id="user-menu-coupon-redeem-title" className="match-explainer-title user-menu-match-removal-confirm-title">
          Redeem coupon
        </h3>
        <p className="user-menu-coupon-redeem-hint">Enter your coupon code.</p>
        <form
          className="user-menu-coupon-redeem-form"
          onSubmit={async (e) => {
            e.preventDefault();
            if (couponSubmitting) return;
            setCouponError('');
            setCouponSubmitting(true);
            try {
              const result = await onRedeemCoupon(couponInput);
              if (result?.ok) {
                onClose?.();
              } else {
                setCouponError(result?.error || 'Could not redeem that code.');
              }
            } catch {
              setCouponError('Something went wrong. Try again.');
            } finally {
              setCouponSubmitting(false);
            }
          }}
        >
          <input
            type="text"
            className="user-menu-coupon-redeem-input"
            value={couponInput}
            onChange={(e) => {
              setCouponInput(e.target.value);
              if (couponError) setCouponError('');
            }}
            placeholder="Code"
            autoComplete="off"
            autoCapitalize="characters"
            disabled={couponSubmitting}
            aria-invalid={!!couponError}
            aria-describedby={couponError ? 'user-menu-coupon-redeem-err' : undefined}
          />
          {couponError ? (
            <p id="user-menu-coupon-redeem-err" className="user-menu-coupon-redeem-error" role="alert">
              {couponError}
            </p>
          ) : null}
          <div className="user-menu-match-removal-confirm-actions user-menu-coupon-redeem-actions">
            <button
              type="button"
              className="vibe-popup-btn match-flow-close-btn"
              disabled={couponSubmitting}
              onClick={closeModal}
            >
              Cancel
            </button>
            <button type="submit" className="vibe-popup-btn" disabled={couponSubmitting}>
              {couponSubmitting ? 'Checking…' : 'Apply'}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body,
  );
}
